import React from 'react';
import { motion, MotionProps } from 'framer-motion';
import { Link, LinkProps } from 'react-router-dom';

type MotionDivProps = React.HTMLAttributes<HTMLDivElement> & MotionProps;
type MotionButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & MotionProps;
type MotionImgProps = React.ImgHTMLAttributes<HTMLImageElement> & MotionProps;
type MotionAnchorProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & MotionProps;
type MotionLinkProps = LinkProps & MotionProps;
type FadeInSectionProps = React.HTMLAttributes<HTMLElement> & MotionProps;

export const MotionCard: React.FC<MotionDivProps> = ({ children, ...rest }) => {
  return (
    <motion.div
      whileHover={{ y: -4, scale: 1.02 }}
      transition={{ type: 'spring', stiffness: 260, damping: 18 }}
      {...rest}
    >
      {children}
    </motion.div>
  );
};

export const MotionButton: React.FC<MotionButtonProps> = ({ children, ...rest }) => {
  return (
    <motion.button
      whileHover={{ y: -2, scale: 1.03 }}
      whileTap={{ scale: 0.98 }}
      transition={{ type: 'spring', stiffness: 260, damping: 20 }}
      {...rest}
    >
      {children}
    </motion.button>
  );
};

export const MotionImage: React.FC<MotionImgProps> = (props) => {
  return (
    <motion.img
      whileHover={{ scale: 1.05 }}
      transition={{ type: 'spring', stiffness: 260, damping: 24 }}
      {...props}
    />
  );
};

export const MotionAnchor: React.FC<MotionAnchorProps> = ({ children, ...rest }) => {
  return (
    <motion.a
      whileHover={{ y: -2, scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      transition={{ type: 'spring', stiffness: 260, damping: 20 }}
      {...rest}
    >
      {children}
    </motion.a>
  );
};

const MotionLinkBase = motion(Link as React.ComponentType<LinkProps>);

export const MotionLink: React.FC<MotionLinkProps> = ({ children, ...rest }) => {
  return (
    <MotionLinkBase
      whileHover={{ y: -2, scale: 1.03 }}
      whileTap={{ scale: 0.98 }}
      transition={{ type: 'spring', stiffness: 260, damping: 20 }}
      {...rest}
    >
      {children}
    </MotionLinkBase>
  );
};

export const FadeInSection: React.FC<FadeInSectionProps> = ({ children, ...rest }) => {
  return (
    <motion.section
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
      {...rest}
    >
      {children}
    </motion.section>
  );
};
